import { fullName } from "../../constants/function";
import { formatCount } from "../../utils/gamification/format";
import { STATUS_LABELS } from "../../utils/gamification/levels";
import { toCdnUrl } from "../../utils/mediaUrl";

// A `/engagement/artist/:id/top-fans` row carries the person under `fan`:
// `{ rank, fanId, fan: { _id, firstName, lastName, displayArtistName, userName, profileImg }, points, ... }`.
// `fan` is null when the backend could not resolve the user.
const person = (row) => row?.fan || row?.user || row;

export const fanId = (row) => row?.userId || row?.fanId || row?.fan?._id || row?.user?._id || row?._id;
export const fanName = (row) => row?.name || fullName(person(row));

// Profile picture URL, or "" when the fan has none. The engagement service
// sends `profileImg` as the bare file path; other endpoints send `{ filePath }`.
export function fanImage(row) {
  const img = row?.image || person(row)?.profileImg;
  const path = typeof img === "string" ? img : img?.filePath;
  return path ? toCdnUrl(path) : "";
}

const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 });
const count = (n, word) => `${formatCount(n)} ${word}${Number(n) === 1 ? "" : "s"}`;

// One line under the name: "$0.54 tipped · 3 streams", or the fan's first
// status with this artist when every 30-day counter is zero.
export function fanFacts(row) {
  const parts = [];
  if (row?.tips > 0) parts.push(`${usd.format(row.tips)} tipped`);
  if (row?.requests > 0) parts.push(count(row.requests, "request"));
  if (row?.streams > 0) parts.push(count(row.streams, "stream"));
  if (row?.referrals > 0) parts.push(count(row.referrals, "referral"));
  if (parts.length) return parts.join(" · ");
  const status = Array.isArray(row?.statuses) ? row.statuses[0] : null;
  return status ? STATUS_LABELS[status] || status : "";
}
